import React from 'react'
import PropTypes from 'prop-types'

const SLIDERS_PATH = 'M9 15.75C8.7875 15.75 8.60938 15.6781 8.46563 15.5344C8.32187 15.3906 8.25 15.21'
  + '25 8.25 15V12C8.25 11.7875 8.32187 11.6094 8.46563 11.4656C8.60938 11.3219 8.787'
  + '5 11.25 9 11.25C9.2125 11.25 9.39063 11.3219 9.53437 11.4656C9.67813 11.6094 9.7'
  + '5 11.7875 9.75 12V12.75H15C15.2125 12.75 15.3906 12.8219 15.5344 12.9656C15.6781'
  + ' 13.1094 15.75 13.2875 15.75 13.5C15.75 13.7125 15.6781 13.8906 15.5344 14.0344C'
  + '15.3906 14.1781 15.2125 14.25 15 14.25H9.75V15C9.75 15.2125 9.67813 15.3906 9.53'
  + '437 15.5344C9.39063 15.6781 9.2125 15.75 9 15.75ZM3 14.25C2.7875 14.25 2.60937 1'
  + '4.1781 2.46562 14.0344C2.32187 13.8906 2.25 13.7125 2.25 13.5C2.25 13.2875 2.321'
  + '87 13.1094 2.46562 12.9656C2.60937 12.8219 2.7875 12.75 3 12.75H6C6.2125 12.75 6'
  + '.39062 12.8219 6.53437 12.9656C6.67813 13.1094 6.75 13.2875 6.75 13.5C6.75 13.71'
  + '25 6.67813 13.8906 6.53437 14.0344C6.39062 14.1781 6.2125 14.25 6 14.25H3ZM6 11.'
  + '25C5.7875 11.25 5.60938 11.1781 5.46562 11.0344C5.32187 10.8906 5.25 10.7125 5.2'
  + '5 10.5V9.75H3C2.7875 9.75 2.60937 9.67813 2.46562 9.53437C2.32187 9.39063 2.25 9'
  + '.2125 2.25 9C2.25 8.7875 2.32187 8.60938 2.46562 8.46563C2.60937 8.32187 2.7875 '
  + '8.25 3 8.25H5.25V7.5C5.25 7.2875 5.32187 7.10937 5.46562 6.96563C5.60938 6.82187'
  + ' 5.7875 6.75 6 6.75C6.2125 6.75 6.39062 6.82187 6.53437 6.96563C6.67813 7.10937 '
  + '6.75 7.2875 6.75 7.5V10.5C6.75 10.7125 6.67813 10.8906 6.53437 11.0344C6.39062 1'
  + '1.1781 6.2125 11.25 6 11.25ZM9 9.75C8.7875 9.75 8.60938 9.67813 8.46563 9.53437C'
  + '8.32187 9.39063 8.25 9.2125 8.25 9C8.25 8.7875 8.32187 8.60938 8.46563 8.46563C8'
  + '.60938 8.32187 8.7875 8.25 9 8.25H15C15.2125 8.25 15.3906 8.32187 15.5344 8.4656'
  + '3C15.6781 8.60938 15.75 8.7875 15.75 9C15.75 9.2125 15.6781 9.39063 15.5344 9.53'
  + '437C15.3906 9.67813 15.2125 9.75 15 9.75H9ZM12 6.75C11.7875 6.75 11.6094 6.67813'
  + ' 11.4656 6.53437C11.3219 6.39062 11.25 6.2125 11.25 6V3C11.25 2.7875 11.3219 2.6'
  + '0937 11.4656 2.46562C11.6094 2.32187 11.7875 2.25 12 2.25C12.2125 2.25 12.3906 2'
  + '.32187 12.5344 2.46562C12.6781 2.60937 12.75 2.7875 12.75 3V3.75H15C15.2125 3.75'
  + ' 15.3906 3.82187 15.5344 3.96562C15.6781 4.10937 15.75 4.2875 15.75 4.5C15.75 4.'
  + '7125 15.6781 4.89062 15.5344 5.03437C15.3906 5.17812 15.2125 5.25 15 5.25H12.75V'
  + '6C12.75 6.2125 12.6781 6.39062 12.5344 6.53437C12.3906 6.67813 12.2125 6.75 12 6'
  + '.75ZM3 5.25C2.7875 5.25 2.60937 5.17812 2.46562 5.03437C2.32187 4.89062 2.25 4.7'
  + '125 2.25 4.5C2.25 4.2875 2.32187 4.10937 2.46562 3.96562C2.60937 3.82187 2.7875 '
  + '3.75 3 3.75H9C9.2125 3.75 9.39063 3.82187 9.53437 3.96562C9.67813 4.10937 9.75 4'
  + '.2875 9.75 4.5C9.75 4.7125 9.67813 4.89062 9.53437 5.03437C9.39063 5.17812 9.212'
  + '5 5.25 9 5.25H3Z'

const SlidersIcon = ({ className = '' }) => (
  <svg
    aria-hidden="true"
    className={className}
    fill="currentColor"
    height="1em"
    viewBox="0 0 18 18"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d={SLIDERS_PATH} />
  </svg>
)

SlidersIcon.propTypes = {
  className: PropTypes.string
}

SlidersIcon.defaultProps = {
  className: ''
}

export default SlidersIcon
